import React from 'react';

import { useButtonStatusAndText } from '@funnels/hooks';

import { OnlyVisibleOnDesktop, OnlyVisibleOnMobileAndTablet } from './index.style';
import { DesktopViewActionButtonsGroup, MobileAndTabletViewActionButtonsGroup } from './ResponsiveViews';

interface ActionButtonsGroupProps {
  handleCancel?: () => void;
  handleSave?: () => void;
  isResponsive?: boolean;
  isLoading: boolean;
  isError: boolean;
}

export function ActionButtonsGroup(props: ActionButtonsGroupProps) {
  const { isResponsive = true, isLoading, isError, ...rest } = props;
  const { buttonStatus, buttonStatusText, isDisabled } = useButtonStatusAndText(isLoading, isError);

  if (!isResponsive) {
    return (
      <DesktopViewActionButtonsGroup
        {...rest}
        buttonStatus={buttonStatus}
        buttonStatusText={buttonStatusText}
        isDisabled={isDisabled}
      />
    );
  }

  return (
    <>
      <OnlyVisibleOnDesktop>
        <DesktopViewActionButtonsGroup
          {...rest}
          buttonStatus={buttonStatus}
          buttonStatusText={buttonStatusText}
          isDisabled={isDisabled}
        />
      </OnlyVisibleOnDesktop>
      <OnlyVisibleOnMobileAndTablet>
        <MobileAndTabletViewActionButtonsGroup
          {...rest}
          buttonStatus={buttonStatus}
          buttonStatusText={buttonStatusText}
          isDisabled={isDisabled}
        />
      </OnlyVisibleOnMobileAndTablet>
    </>
  );
}
